import { schema } from "normalizr";

export const faqSchema = new schema.Entity("faq", {});

export const faqsSchema = new schema.Array(faqSchema);
